<script setup>
import {Swiper, SwiperSlide} from "swiper/vue";
import {Autoplay, Navigation} from 'swiper/modules';
import 'swiper/css';
import CLink from "@/Components/CLink.vue";
import {useDisplay} from "vuetify";
import {computed} from "vue";

const props = defineProps({
    campaigns: Object
})

const modules = [Autoplay, Navigation];

const display = useDisplay()

const sizes = computed(() => {
    if (display.width.value <= 640) return 'small'
    if (display.width.value <= 1023) return 'medium'
    if (display.width.value <= 1439) return 'large'
    if (display.width.value <= 1680) return 'extra-large'
})

const displayPromoCard = computed(() => {
    switch (sizes.value) {
        case 'small' :
            return (display.width.value / 3) / 1.8
        case 'medium' :
            return (display.width.value / 4) / 1.7
        case 'large' :
            return (display.width.value / 3) / 1.46
        case 'extra-large' :
            return (display.width.value / 4) / 1.48
        default :
            return (display.width.value / 4) / 1.45
    }
})

const redirectLink = function (item) {
    const url = defaultUrl(item)

    if (url === '') {
        return '_self'
    }

    const urlObj = new URL(url);
    if (urlObj.host !== 'creativedesign.com.br') {
        return '_blank';
    } else {
        return '_self'
    }
}

const hasUrl = function (item) {
    return item.url &&
        typeof item.url === 'string' &&
        item.url.trim() !== ''
}

const defaultUrl = function (item) {
    return hasUrl(item) ? item.url : ''
}

</script>


<template>
    <v-sheet class="mb-5 w-75 mx-auto">
        <swiper
            :modules="modules"
            :slides-per-view="4"
            :pagination="{
                            clickable: true,
                            dynamicBullets: false
                        }"
            :navigation="{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        }"
            :loop="true"
            :breakpoints="{
                            320: {slidesPerView: 3},
                            640: {slidesPerView: 3},
                            768: {slidesPerView: 4},
                            1024: {slidesPerView: 3},
                            1040: {slidesPerView: 4},
                        }"
        >
            <swiper-slide v-for="campaign in campaigns" :key="campaign.display_order" class="bg-white">
                <a :href="defaultUrl(campaign)" :target="redirectLink(campaign)">
                    <v-img :src="campaign.campaign_url" :width="displayPromoCard" class="slide-image"/>
                </a>
            </swiper-slide>
        </swiper>
        <v-row style="min-height: 55px" class="ma-0 bg-white">
            <v-col class="d-flex justify-start mt-1 px-0">
                <div class="swiper-button-prev text-institutionalGrey"></div>
                <div class="swiper-button-next text-institutionalGrey"></div>
            </v-col>
            <v-col class="d-flex justify-end mt-2 ">
                <c-link :href="route('campaigns')" class="promotion-link text-institutionalGrey">
                    Confira todas as <strong>Campanhas</strong>
                </c-link>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<style scoped>
.slide-image {
    margin-right:  2rem
}

.swiper-slide {
    width: initial !important;
    justify-content: center;
}

.swiper-button-next,
.swiper-button-prev {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    margin: 0;
    width: 30px;
    height: 30px;
}

.swiper-button-next:after,
.swiper-button-prev:after {
    font-size: 1rem;
    font-weight: bolder;
}

.promotion-link {
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s ease;
    position: absolute;
}

.promotion-link:hover {
    color: rgba(0, 0, 0, 0.46);
}

.promotion-link::after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.46);
    transition: width 0.3s ease;
}

.promotion-link:hover::after {
    width: 100%;
}

@media (max-width: 640px) {
    .swiper-button-next:after,
    .swiper-button-prev:after {
        font-size: 1rem;
    }

    .promotion-link {
        font-size: 0.7rem;
    }
}
</style>
